import { render } from "./detailsDialog.vue?vue&type=template&id=e3d7dd7c&scoped=true"
import script from "./detailsDialog.vue?vue&type=script&lang=js"
export * from "./detailsDialog.vue?vue&type=script&lang=js"

import "./detailsDialog.vue?vue&type=style&index=0&id=e3d7dd7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3d7dd7c"]])

export default __exports__